import { reactive } from "vue";

export type ToastType = "success" | "danger" | "warning";

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
}

let nextId = 1;

export const toasts = reactive<Toast[]>([]);

export function showToast(
  message: string,
  type: ToastType = "success",
  timeout = 4200
) {
  const toast = { id: nextId++, type, message };
  toasts.push(toast);
  if (timeout > 0) {
    window.setTimeout(() => removeToast(toast.id), timeout);
  }
  return toast.id;
}

export function removeToast(id: number) {
  const index = toasts.findIndex((toast) => toast.id === id);
  if (index >= 0) toasts.splice(index, 1);
}

export const toast = {
  success(message: string) {
    return showToast(message, "success");
  },
  danger(message: string) {
    return showToast(message, "danger", 6000);
  },
  warning(message: string) {
    return showToast(message, "warning", 3600);
  },
};
